<div class="row">
  @if (displayNewRequestForm) {
    <div class="message-container blue-fill mb-3">
      <mwp-text-translate text="New Life Event Request" jsonKey="qleNewLifeEventRequest" />
    </div>
    <form [formGroup]="newRequestForm" class="col-12">
      <div class=" content-container mb-3">
        <div class="title">
          <mwp-text-translate text="Event Details" jsonKey="eventDetails" />
        </div>
        <div class="content row">
          <div class="col-3 mb-3">
            <mwp-dropdown labelName="Select Life Event" [form]="newRequestForm" [data]="adminEventOptions" keyText="description" keyValue="id" nameForControl="adminEventId" />
          </div>
          <div class="col-3 mb-3">
            <mwp-datepicker [form]="newRequestForm" labelName="Date of Event" nameForControl="eventDate" />
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button class="mwp-button-secondary mx-3" (click)="cancelForm()">
          <mwp-text-translate text="Return" jsonKey="return" />
        </button>
        <button class="mwp-button wide" (click)="saveQLE()" [disabled]="!newRequestForm.valid">
          <mwp-text-translate text="Next" jsonKey="next" />
        </button>
      </div>
    </form>
  }

  @if (displayRequestForm) {
    <div class="row">
      <div class="col-6 mb-3">
        <form [formGroup]="requestForm" class="">
          <div class="col-12 content-container form-comp mb-3">
            <div class="title">
              <mwp-text-translate text="Event Details" jsonKey="eventDetails" />
            </div>
            <div class="row content">
              <div class="col-6 mb-3">
                <mwp-input [form]="requestForm" labelName="Event Type" nameForControl="lifeEventName" />
              </div>
              <div class="col-6 mb-3">
                <mwp-datepicker [form]="requestForm" labelName="Date of Event" nameForControl="eventDate" />
              </div>
            </div>
          </div>
          <div class="content-container form-comp">
            <div class="title controls">
              <mwp-text-translate text="Documents" jsonKey="Documents" />
              <div class="control-area d-flex justify-content-end">
                <button class="mwp-button" [disabled]="!canEdit" (click)="openUploadDialog()">
                  <mwp-text-translate text="Upload Documents" jsonKey="qleUploadDocuments" />
                </button>
              </div>
            </div>
            <div class="content">
              <mwp-table [tableColumns]="documentColumns" [dataSource]="documentTableData" (emitButtonSelection)="deleteDocument($event)" />
            </div>
          </div>
        </form>
      </div>
      <div class="col-6 mb-3 ps-0">
        <div class="content-container has-controls">
          <div class="title">
            <mwp-text-translate text="Notes" jsonKey="notes" />
          </div>
          <div class="note-table">
            <div class="content has-controls">
              @if (noteInformationText) {
                <div [innerHTML]="noteInformationText | pipeSafeHTML"></div>
              }
              @if (chats && chats.chatEntries.length > 0) {
                <div class="note-container">
                  <div class="content-container mb-3">
                    <div class="note-box">
                      <ol class="notes">
                        @for (chat of chats.chatEntries; track chat) {
                          <li [ngClass]="chat.createdBy == 'MEMBER' ?'qle-member ' : 'qle-admin '">
                            @if (chat.createdBy !== 'MEMBER') {
                              <div [ngClass]="chat.createdBy == 'MEMBER' ?'col-3' : 'message col-9'">
                                <div class="message-name-date col-12">
                                  <div>{{chat.createdBy}}</div>
                                  <div>{{chat.createdOn}}</div>
                                </div>
                                <div class="message-chat">
                                  {{chat.chat}}
                                </div>
                              </div>
                            }
                            @if (chat.createdBy == 'MEMBER') {
                              <div [ngClass]="chat.createdBy == 'MEMBER' ?'message col-9' : 'col-3'">
                                <div class="message-name-date col-12">
                                  <div>{{memberName}}</div>
                                  <div>{{chat.createdOn}}</div>
                                </div>
                                <div class="message-chat">
                                  {{chat.chat}}
                                </div>
                              </div>
                            }
                          </li>
                        }
                      </ol>
                    </div>
                  </div>
                </div>
              }
              @if (!chats || chats.chatEntries.length == 0) {
                <div class="mb-3 fw-bold">
                  <mwp-text-translate text="No Notes Found!" jsonKey="qleNoNotesFound" />
                </div>
              }
            </div>
          </div>
          <div class="content  mb-3">
            <form [formGroup]="newNoteForm">
              @if (canEdit) {
                <div class="mt-3 chat-input">
                  <mwp-textarea [form]="newNoteForm" nameForControl="note" labelName="Type Note Here" height="133px" />
                </div>
              }
            </form>
            @if (canEdit) {
              <div class="d-flex justify-content-end mt-3">
                <button class="mwp-button" (click)="addNote()" [disabled]="!newNoteForm.valid">
                  <mwp-text-translate text="Send Note" jsonKey="sendNote" />
                </button>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between w-100 pt-2">
        <div>
          
        </div>
        <div class="d-flex justify-content-end ">
          <div>
            <button class="mwp-button-secondary" (click)="cancelForm()">
              <mwp-text-translate text="Return" jsonKey="return" />
            </button>
          </div>
          @if (canCancel) {
            <div>
              <button class="mwp-button-delete ms-3" (click)="cancelQLE()">
                {{cancelText}}
              </button>
            </div>
          }
          @if (canEdit) {
            <div>
              <button class="mwp-button-save ms-3" (click)="saveQLE()" [disabled]="!requestForm.valid || requestForm.pristine">
                <mwp-text-translate text="Save Changes" jsonKey="saveChanges" />
              </button>
            </div>
            <div>
              <button class="mwp-button ms-3" (click)="submit()">
                <mwp-text-translate text="Submit for Review" jsonKey="submitForReview" />
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  }

</div>